import { SearchFilter } from '@aibees/elephant/feature/search-filters/types';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { getTags } from '../utils';

export function useFilterTags(
  params: Partial<SearchBrowseParams>,
  filter: SearchFilter
) {
  return useMemo(() => getTags(params, filter), [filter, params]);
}
